import OText from 'components/CText/OText';
import { BannerCta } from './BannerCta';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import classnames from 'classnames';

export const PlusOverviewBannerCustomHtmlView = props => {
  const { copyConfig, ctaConfig, isTwoModules } = props ?? {};
  const { htmlConfig } = copyConfig;
  const wrapperClassnames = classnames('m-flex-column', {
    'flex-column': isTwoModules,
  });
  const bannerSectionClassnames = classnames('m-format100', {
    format100: isTwoModules,
    format68: !isTwoModules,
  });
  const ctaSectionClassnames = classnames(' m-format100 m-justify-center', {
    'format100 justify-center': isTwoModules,
    format32: !isTwoModules,
  });
  return (
    <>
      <FlexContainer className={wrapperClassnames}>
        <FlexContainer
          justifyBetween
          alignItemsCenter
          className={bannerSectionClassnames}
        >
          <OText text={htmlConfig} />
        </FlexContainer>
        <FlexContainer className={ctaSectionClassnames}>
          <BannerCta {...ctaConfig} isTwoModules={isTwoModules} />
        </FlexContainer>
      </FlexContainer>
    </>
  );
};
